type DeviceNavigationSnapshot = {
  id: string
  type?: string
} | null

export interface DeviceNavigationContext {
  routeDeviceType?: string
  oldDevice: DeviceNavigationSnapshot
  newDevice: DeviceNavigationSnapshot
  isUserNavigating: boolean
  isFirmwareUpdating: boolean
  isParentChildSwitch: boolean
  hasParentRelationChanged: boolean
}

/**
 * 判断当前设备变化是否必须退出设备专属页面。
 *
 * `/device/**` 页面绑定了具体设备实例，后台切到其他设备后继续停留可能把设置写给错误设备；
 * 配置中心等跨设备页面本来就允许切换设备，不应套用该保护。
 */
export function shouldLeaveDeviceRoute(context: DeviceNavigationContext): boolean {
  const {
    routeDeviceType,
    oldDevice,
    newDevice,
    isUserNavigating,
    isFirmwareUpdating,
    isParentChildSwitch,
    hasParentRelationChanged,
  } = context

  if (!routeDeviceType || isUserNavigating || isFirmwareUpdating || isParentChildSwitch) {
    return false
  }

  // 设备类型已经不适用于当前路由（包括当前设备断开变为 null）。
  if (newDevice?.type !== routeDeviceType) return true

  // 初始化设备页时 oldDevice 为空，不视为设备切换；已有设备实例变化则必须退出。
  return oldDevice !== null && (oldDevice.id !== newDevice.id || hasParentRelationChanged)
}
